const reduceDetectedUiActivity = (state, data) => ({ ...state, latest: { ...data } });

// noinspection JSUnusedGlobalSymbols
export default reduceDetectedUiActivity;
